import { render, staticRenderFns } from "./FFAssignModal.vue?vue&type=template&id=48a15814"
import script from "./FFAssignModal.vue?vue&type=script&lang=js"
export * from "./FFAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports